import { Controller } from "stimulus"

export default class extends Controller {
  static values = { src: String }

  connect() {
    this.element.addEventListener("change", this.changeHandler)
  }

  disconnect() {
    this.element.removeEventListener("change", this.changeHandler)
  }

  changeHandler = e => {
    const location = this.srcValue.replaceAll(encodeURIComponent(":value"), e.target.value)
    Turbo.visit(location, { frame: this.element.dataset.turboFrame })
  }

  update(e) {
    this.element.src = e.detail.src
  }
}
